import { StepKeys } from "@/pages/SetupWorkflow/constants";
import { Button, Icons, LinkButton } from "@flash-tecnologia/hros-web-ui-v2";
import { Step } from "bff/src/services";
import { useNavigate } from "react-router-dom";

export interface ListItemActionsProps {
  step: Step;
  onClick: () => void;
  onSkipToggle?: () => void;
}

export const ListItemActions = ({
  step,
  onClick,
  onSkipToggle,
}: ListItemActionsProps) => {
  const navigate = useNavigate();

  const showCta = step.status === "PENDING" || step.status === "DOING";
  const showToggleSkip = !step.required && step.status !== "COMPLETED";
  const completedAction = getCompletedAction(step.externalId);

  const onCompletedActionClick = () => {
    if (completedAction?.redirectPath) {
      navigate(completedAction.redirectPath);
    }
  };

  if (step.status === "COMPLETED" && completedAction?.text) {
    return (
      <LinkButton
        variant="default"
        onClick={onCompletedActionClick}
        underlined={false}
        size="small"
      >
        {completedAction.text} <Icons name="IconExternalLink" size={16} />
      </LinkButton>
    );
  }

  return (
    <>
      {showToggleSkip && (
        <LinkButton
          variant="neutral"
          onClick={onSkipToggle}
          underlined={false}
          size="small"
        >
          {step.status === "SKIPPED" ? (
            <>
              <Icons name="IconEye" size={16} /> Reconsiderar
            </>
          ) : (
            <>
              <Icons name="IconEyeOff" size={16} /> Ignorar
            </>
          )}
        </LinkButton>
      )}
      {showCta && (
        <Button variant="primary" onClick={onClick} size="small">
          {step.status === "DOING"
            ? "Continuar"
            : getButtonText(step.externalId)}
        </Button>
      )}
    </>
  );
};

const getButtonText = (externalId: string) => {
  switch (externalId) {
    case StepKeys.ADD_MEMBERS:
      return "Convidar";
    case StepKeys.ADD_COMPANIES:
      return "Adicionar";
    case StepKeys.KYC:
    default:
      return "Validar";
  }
};

const getCompletedAction = (externalId: string) => {
  switch (externalId) {
    case StepKeys.ADD_MEMBERS:
      return {
        text: "Acessar equipe",
        redirectPath: "/employees",
      };
    case StepKeys.ADD_COMPANIES:
      return {
        text: "Acessar gestão de grupo",
        redirectPath: "/settings/economic-group",
      };
    case StepKeys.KYC:
      return {
        text: "Acessar validação",
        redirectPath: "/settings/company",
      };
  }
};
